import { calcHctCai, limitKtj as limitKtjByParcel } from '@g/utils/parcelUtils'

export const LIMIT_KTJ_STRATEGIES = Object.freeze({
  PC_LEGACY: 'pc-legacy',
  H5_PARCEL_UTILS: 'h5-parcel-utils',
})

export function computeLimitKtj ({ strategy, parcelAddrid, parcels, transport }) {
  // 上海、福州、江阴的大荣不设置体积和重量限制。
  if (['1210', '1598', '1591', '1050'].includes(parcelAddrid)) return false

  if (strategy === LIMIT_KTJ_STRATEGIES.PC_LEGACY) {
    if (parcels.find(item => item.weight > 30000)) return true
    if (parcels.find(item => calcHctCai(item) > 10)) return true
    if (parcels.find(item => item.width > 3200 || item.height > 3200 || item.length > 3200)) return true
    if (parcels.find(item => item.width > 1650 && item.height > 1650 && item.length > 1650)) return true
    return false
  }

  if (strategy === LIMIT_KTJ_STRATEGIES.H5_PARCEL_UTILS) {
    return !!parcels.find(parcel => limitKtjByParcel(parcel, transport))
  }

  throw new Error(`未知 limitKtj strategy: ${strategy}`)
}
